import { lazy } from "react";
// import MainLayout from "layouts/MainLayout";

export const routes = [
    {
        path: '/*',
        component: lazy(() => import('../pages/Home')),
        // layout: MainLayout
    }
]